import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-applicationsguarantor',
  templateUrl: './applicationsguarantor.component.html',
  styleUrls: ['./applicationsguarantor.component.css']
})
export class ApplicationsguarantorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
